import { Buffer } from "buffer";

export type DecoderFn = (buf: Buffer) => Record<string, any>;

export interface RegistryEntry {
  programId: string;
  context: "instruction" | "trade" | "event";
  type: string;
  decode: DecoderFn;
}

export const DECODER_REGISTRY = new Map<string, RegistryEntry>();

export function registerDecoder(
  discriminator: string | null,
  entry: RegistryEntry
) {
  const key = discriminator
    ? `${entry.programId}:${discriminator}`
    : `${entry.programId}:${entry.context}`;

  DECODER_REGISTRY.set(key, entry);
}
